// src/services/verification.service.ts
import { apiClient } from "../components/shared/services/api/axios.config";
import { handleApiError } from "../components/shared/utils/commonApiError";
import {
  InitiateVerificationRequest,
  InitiateVerificationResponse,
  VerifyOtpRequest,
  VerifyOtpResponse,
} from "../components/shared/verification.types";
import { validateIndianPhoneNumber } from "../components/shared/utils/valid";
import { authService } from "../components/shared/services/auth.service";
import { AxiosResponse } from "axios";
import { userDbService } from "./user.storage.service";

class VerificationService {
  async initiateVerification(
    phoneNumber: string
  ): Promise<InitiateVerificationResponse> {
    console.log("[VerificationService] Initiating phone verification...", {
      phoneNumber,
    });
    const val = validateIndianPhoneNumber(phoneNumber);
    // Validate phone number format first
    if (!val.isValid) {
      console.error("[VerificationService] " + val.error);
      throw val.error;
    }

    try {
      const request: InitiateVerificationRequest = {
        phoneNumber,
      };

      console.log("[VerificationService] Calling initiate verification API...");
      const response = await apiClient.post<InitiateVerificationResponse>(
        "/phone/initiate-verification-consumer",
        request
      );

      console.log("[VerificationService] Verification initiated successfully");
      return response.data;
    } catch (error) {
      console.error(
        "[VerificationService] Failed to initiate verification:",
        error
      );
      throw handleApiError(error);
    }
  }

  async verifyOtp(
    verificationSessionId: string,
    otpCode: string,
    phoneNumber: string
  ): Promise<VerifyOtpResponse> {
    console.log("[VerificationService] Verifying OTP...", {
      verificationSessionId,
    });

    try {
      const request: VerifyOtpRequest = {
        verificationSessionId,
        otpCode,
        phoneNumber,
      };

      console.log("[VerificationService] Calling verify OTP API...");
      const response: AxiosResponse<VerifyOtpResponse> =
        await apiClient.post<VerifyOtpResponse>(
          "/phone/verify-otp-consumer",
          request
        );

      const data: VerifyOtpResponse = response.data;
      console.log("response:", data);

      // If verification successful, update stored tokens
      if (data.verification_status) {
        console.log(
          "[VerificationService] OTP verification successful, updating tokens..."
        );
        //OTP Verified store auth data in secure store and userdata in DB.

        //save authtoken
        await authService.updateTokens(data.auth_token, data.refresh_token);

        //save in sqlite
        await userDbService.saveUser(data.user);
      }

      console.log("[VerificationService] Verification process completed");
      return data;
    } catch (error) {
      console.error("[VerificationService] Failed to verify OTP:", error);
      throw handleApiError(error);
    }
  }
}

export const verificationService = new VerificationService();
